export default "__VITE_ASSET__Dhj3BkIl__"